import React, { useContext, useEffect, useMemo, useRef } from 'react'
import * as classes from "./FirstScreenV2.module.scss"
import { FormContext } from '../../../../context'
import { useWindowSize } from '../../../../hooks/useWindowSize'
import { useDataFirstScreenByHy } from './useDataFirstScreenByHy'
import { useDataFirstScreenByEn } from './useDataFirstScreenByEn'
import { getCmsPosterUrl, getCmsVideoUrl } from '../../../../utils/getCmsVideoUrl'

const MOBILE_MAX_WIDTH = 767

export default function FirstScreenV2({lang}) {
    const { animationStart } = useContext(FormContext)
    const video = useRef(null)
    const windowSize = useWindowSize()

    const mainVideoByHy = useDataFirstScreenByHy()
    const mainVideoByEn = useDataFirstScreenByEn()

    const mainVideo = lang === 'en' ? mainVideoByEn : mainVideoByHy
    const isMobile = typeof windowSize.width === 'number' ? windowSize.width <= MOBILE_MAX_WIDTH : null

    const { videoSrc, posterSrc } = useMemo(() => {
        if (isMobile === null) {
            return { videoSrc: '', posterSrc: '' }
        }

        const asset = isMobile ? mainVideo?.videoMobile : mainVideo?.videoDesktop
        const poster = isMobile ? mainVideo?.posterMobile : mainVideo?.posterDesktop

        return {
            videoSrc: getCmsVideoUrl(asset),
            posterSrc: getCmsPosterUrl(poster, asset)
        }
    }, [isMobile, mainVideo])

    useEffect(() => {
        if (video.current && videoSrc) {
            video.current.load()
        }
    }, [videoSrc])

    useEffect(() => {
        if (!animationStart || !video.current || !videoSrc) {
            return
        }

        const played = video.current.play()

        if (played && typeof played.catch === 'function') {
            played.catch(() => {})
        }
    }, [animationStart, videoSrc])

    return (
        <div className={classes.FirstScreenV2}>
            {videoSrc ? (
                <video
                    ref={video}
                    muted
                    preload="auto"
                    data-keepplaying="data-keepplaying"
                    playsInline
                    loop
                    poster={posterSrc || undefined}
                >
                    <source src={videoSrc} type="video/mp4"/>
                </video>
            ) : null}
        </div>
    )
}
